import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
//import {Select, Checkbox, FormControlLabel, MenuItem, InputLabel, FormControl } from '@mui/material';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/base/Portal';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
//import moment from 'moment';
import axios from 'axios';

import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const userObj = useSelector(state => state.userDetails);
  const [formReset, setFormReset] = React.useState(false);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const [title, setTitle] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [pinCode, setPinCode] = React.useState("");
  const [country, setCountry] = React.useState("");

  // var myCurrentDate=new Date();
	// var myDate=new Date(myCurrentDate);
  // myDate.setDate(myDate.getDate() - 6540);
	// const [dobDate, setDobDate] = React.useState(moment(myDate).format('YYYY-MM-DD'));
  // const [dobDate, setDobDate] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setFormReset(!formReset);
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    
    if(props.dataObj && props.dataObj.autoId){
      setTitle(props.dataObj.title);
      setAddress(props.dataObj.address);
      setCity(props.dataObj.city);
      setState(props.dataObj.state);
      setPinCode(props.dataObj.zipCode);
      setCountry(props.dataObj.country);

    }else{
      setTitle("");
      setAddress("");
      setCity("");
      setState("");
      setPinCode("");
      setCountry("");
      

    }


	}, [props.dataObj,open]);
  
  

	function saveData(){
    if(!title){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter title");			
      return false;
    }
    if(!address){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter address");			
      return false;
    }


		if(title && address){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': userObj.registerId,
          'uid': userObj.loginId,
          'fullName': userObj.fullName,
          'token': userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('title', title);
      data.append('address', address);
      data.append('city', city);
      data.append('state', state);
      data.append('zipCode', pinCode);
      data.append('country', country);
      data.append('accountId', props.accountId);
      data.append('ownerId', props.ownerId);

      let apiURL='/crm-create-account-address';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-account-address';
      }
      setSaveLoading(true);       
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);        
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setFormReset(!formReset);
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Address has been saved.");
          props.updatedList(response.data.list);
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Address could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function numberOnly(event){
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    } 
  }

  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} Address</h4></div>

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Title" onChange={event => setTitle(event.target.value)} value={title} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Address" onChange={event => setAddress(event.target.value)} value={address} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="City" onChange={event => setCity(event.target.value)} value={city} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="State" onChange={event => setState(event.target.value)} value={state} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Pin Code" onChange={event => setPinCode(event.target.value)} value={pinCode} onKeyPress={(event)=>{numberOnly(event)}} inputProps={{maxlength:6}}  fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Country" onChange={event => setCountry(event.target.value)} value={country} fullWidth variant="outlined" size='small' />
                          </Grid>


                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Wait</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

    </>
  );

});

export default CustomizedDialogs;